import styled from "styled-components";
import { styled as muiStyled } from '@mui/system'

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 250, 251, 0.98) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-bottom: 1px solid rgba(116, 80, 170, 0.12);
  box-shadow: 
    0 4px 16px rgba(116, 80, 170, 0.08),
    0 2px 8px rgba(0, 0, 0, 0.04),
    0 0 0 1px rgba(116, 80, 170, 0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 12px 20px;
    box-shadow: 
      0 2px 8px rgba(116, 80, 170, 0.06),
      0 1px 4px rgba(0, 0, 0, 0.03);
  }

  @media (max-width: 480px) {
    padding: 10px 16px;
  }
`

export const HeaderGreeting = styled.div`
  color: ${props => props?.main ? '#1a1a1a' : '#6b7280'};
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: normal;
  line-height: ${props => props?.main ? '1.3' : '1.5'};
  font-size: ${props => props?.main ? '24px' : '13px'};
  font-weight: ${props => props?.main ? '700' : '500'};
  letter-spacing: ${props => props?.main ? '-0.02em' : '0'};
  transition: color 0.2s ease;

  @media (max-width: 768px) {
    font-size: ${props => props?.main ? '20px' : '12px'};
  }

  @media (max-width: 480px) {
    font-size: ${props => props?.main ? '18px' : '11px'};
  }
`

export const HeaderLinkText = styled.div`
  color: #6b7280;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: normal;
  line-height: 1.5;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-right: 24px;
  padding: 8px 12px;
  border-radius: 10px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 12px;
    right: 12px;
    height: 2px;
    background: linear-gradient(90deg, #7450aa 0%, #5a3d88 100%);
    border-radius: 2px;
    opacity: 0;
    transform: scaleX(0);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    color: #7450aa;
    background: rgba(116, 80, 170, 0.06);
    transform: translateY(-1px);

    &::after {
      opacity: 1;
      transform: scaleX(1);
    }
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 800px) {
    display: none;
  }
`
